// extracted by mini-css-extract-plugin
module.exports = {"disabled":"TestimonialsItems_disabled__37er-"};